var React = require('react');

function CheckBoxDisabledWithValue (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ð  Checkbox"},[React.createElement("rect",{"id":"Rectangle 12","width":"16","height":"16","rx":"2","fill":"#00121A","fillOpacity":"0.38","key":0}),React.createElement("path",{"id":"Tick","fillRule":"evenodd","clipRule":"evenodd","d":"M13.3137 5.41421L11.8995 4L6.24264 9.65685L3.41421 6.82843L2 8.24264L4.82843 11.0711L6.24264 12.4853L7.65685 11.0711L13.3137 5.41421Z","fill":"white","key":1})]));
}

CheckBoxDisabledWithValue.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckBoxDisabledWithValue;

CheckBoxDisabledWithValue.default = CheckBoxDisabledWithValue;
